import {gql} from '@apollo/client'

export const TRASH_ITEMS = gql`
  mutation TrashItems($input: ItemsInput!) {
    trashItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`

export const RESTORE_ITEMS = gql`
  mutation RestoreItems($input: ItemsInput!) {
    restoreItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`

export const PURGE_ITEMS = gql`
  mutation PurgeItems($input: ItemsInput!) {
    purgeItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`
